"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../../model/types/EventType");
var AbstractEvent_1 = require("./AbstractEvent");
var Id_1 = require("../types/Id");
var DashboardViewedEvent = (function (_super) {
    __extends(DashboardViewedEvent, _super);
    function DashboardViewedEvent(homeIds) {
        var _this = _super.call(this) || this;
        _this.props = new DashboardViewedEventProperties(homeIds.map(function (i) { return new Id_1.Id(i); }));
        return _this;
    }
    DashboardViewedEvent.prototype.getType = function () {
        return EventType_1.EventType.DashboardViewed;
    };
    return DashboardViewedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.DashboardViewedEvent = DashboardViewedEvent;
var DashboardViewedEventProperties = (function () {
    function DashboardViewedEventProperties(home_ids) {
        this.home_ids = home_ids;
    }
    return DashboardViewedEventProperties;
}());
//# sourceMappingURL=DashboardViewedEvent.js.map